import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const TileStyled = styled.li`
  background-color: ${colors.neutral[100]};
  border-radius: 0.5rem;
  box-shadow: ${boxShadows.dark[2]};
  flex-basis: 31.5%;
  text-align: center;
  padding: 2rem 1rem 3rem;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const ActionButtonStyled = styled.button`
  margin: 1rem auto 0;
  text-transform: uppercase;
  display: block;
  background-color: transparent;
  border: none;
  color: ${colors.blue[600]};
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 700;
  font-family: inherit;
  letter-spacing: 0.03rem;
  cursor: pointer;
`;

export const MessageStyled = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.03rem;
  margin: 1rem 0 0;
`;
